export enum SearchTypes {
  Item = 1,
  Course = 2
}

export enum SortTypes {
  Recently = 1,
  Alphabetical = 2
}
